var map = {
	"./intl-en": [
		126,
		0,
		3,
		1
	],
	"./intl-en.js": [
		126,
		0,
		3,
		1
	],
	"./intl-fr": [
		127,
		0,
		4,
		2
	],
	"./intl-fr.js": [
		127,
		0,
		4,
		2
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 202;
module.exports = webpackAsyncContext;